/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Starting_StatusInputs */



/**
* | output |
* | --- |
* | "Starting audio render..." |
*
* @param {Render_Audio_Starting_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_starting_status = /** @type {((inputs?: Render_Audio_Starting_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Starting_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage du rendu audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Rendering wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio rendering audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало обработки звука...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando la renderización de audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始音频渲染……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオのレンダリングを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो रेंडरिंग शुरू हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a renderização de áudio...")
	return /** @type {LocalizedString} */ ("Starting audio render...")
});